import React from 'react'
import { ReturnCard } from '../shared/sso-workspace/return-card'

// Where an impersonated tab lands after "End impersonation" when the browser
// won't let it close itself. The impersonation is already over server-side.
export const OpenImpersonationEnded = () =>
  <ReturnCard
    variant="ended"
    id="impersonation-ended-title"
    title="Impersonation ended"
    lede="You're no longer signed in as someone else in this tab."
    hint="You can close this tab." />
